// @flow

import { loadStripe } from '@stripe/stripe-js';
import config from 'main-app/config';

let stripePromise = null;

export function getStripe() {
  if (!stripePromise && config.stripePublishableKey) {
    stripePromise = loadStripe(config.stripePublishableKey);
  }
  return stripePromise;
}

export function isStripeConfigured(): boolean {
  return Boolean(config.stripePublishableKey);
}
